export default function (url) {
  if (url === undefined) return
  if (!url.replace) return url

  return url.replace(/^.*?\/api|^api/, '')
}
